import { Material } from '../store/material/Material';

export default (a: Material, b: Material) => {
  if (a.price < b.price) return +1;
  if (a.price > b.price) return -1;
  return 0;
};
